import { cn } from '@/lib/utils';

export function FormCard({ className, children }) {
  return (
    <div
      className={cn(
        'rounded-xl border border-grid bg-paper p-5 shadow-[0_1px_0_var(--color-grid),0_24px_48px_-32px_rgb(43_48_44/0.3)] sm:p-8 lg:p-10',
        className
      )}
    >
      {children}
    </div>
  );
}